var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"ss-btn-text ss-btn-text--md",attrs:{"v-bind":_vm.$attrs},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"size":"20","left":""}},[_vm._v("mdi-chevron-left")]),_c('span',{staticClass:"ss-btn-text__label"},[_vm._v(_vm._s(_vm.$t('buttons.back')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }